import { render, staticRenderFns } from "./InfoView_PrivacyPolicy.vue?vue&type=template&id=4d5f7318&"
import script from "./InfoView_PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./InfoView_PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./InfoView_PrivacyPolicy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports